export function index(applicationId)
{
    return axios.get(route('api.manage.applications.timeline', { applicationId }) + '?include=eventable')
        .then(response => response.data);
}
